export const GET_DPP_DOCUMENTS_REQUEST = "GET_DPP_DOCUMENTS_REQUEST";
export const GET_DPP_DOCUMENTS_SUCCESS = "GET_DPP_DOCUMENTS_SUCCESS";
export const GET_DPP_DOCUMENTS_FAILURE = "GET_DPP_DOCUMENTS_FAILURE";

export const GET_DELETE_DOCUMENTS_REQUEST = "GET_DELETE_DOCUMENTS_REQUEST";
export const GET_DELETE_DOCUMENTS_SUCCESS = "GET_DELETE_DOCUMENTS_SUCCESS";
export const GET_DELETE_DOCUMENTS_FAILURE = "GET_DELETE_DOCUMENTS_FAILURE";


export const CREATE_DPPDOCUMENTS_REQUEST = "CREATE_DPPDOCUMENTS_REQUEST";
export const CREATE_DPPDOCUMENTS_SUCCESS = "CREATE_DPPDOCUMENTS_SUCCESS";
export const CREATE_DPPDOCUMENTS_FAILURE = "CREATE_DPPDOCUMENTS_FAILURE";

export const EDIT_DOCUMENTS_REQUEST = "EDIT_DOCUMENTS_REQUEST";
export const EDIT_DOCUMENTS_SUCCESS = "EDIT_DOCUMENTS_SUCCESS";
export const EDIT_DOCUMENTS_FAILURE = "EDIT_DOCUMENTS_FAILURE";

export const UPLOAD_DOCUMENTS_REQUEST = "UPLOAD_DOCUMENTS_REQUEST";
export const UPLOAD_DOCUMENTS_SUCCESS = "UPLOAD_DOCUMENTS_SUCCESS";
export const UPLOAD_DOCUMENTS_FAILURE = "UPLOAD_DOCUMENTS_FAILURE";

export const UPLOAD_IMAGES_REQUEST = "UPLOAD_IMAGES_REQUEST";
export const UPLOAD_IMAGES_SUCCESS = "UPLOAD_IMAGES_SUCCESS";
export const UPLOAD_IMAGES_FAILURE = "UPLOAD_IMAGES_FAILURE";
